import { parseHexColor } from '../parseHexColor'
import { parseRGBString } from '../parseRGBString'

export const processRGBAFromString = (color: string) => {
  if (typeof color === 'string') {
    if (color.startsWith('rgb')) {
      const rgba = parseRGBString(color)
      if (rgba) {
        const { r, g, b, a } = rgba
        return { red: r, green: g, blue: b, alpha: a }
      }
    }
    if (color.startsWith('#')) {
      const { r, g, b, a } = parseHexColor(color)
      return { red: r, green: g, blue: b, alpha: a }
    }
  }
  return null
}
